import 'arrive';
import Swiper from 'swiper/bundle';

document.arrive('.block-carousel-advantages', { existing: true }, function (el) {
  const container = el.querySelector('.block-carousel-advantages__grid.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  // Mark as initialized to avoid duplicates
  container.dataset.swiperInitialized = 'true';

    // Support both custom and default classes for navigation buttons
  const nextEl = container.querySelector('.swiper-button-next, .button-next');
  const prevEl = container.querySelector('.swiper-button-prev, .button-prev');

  // On mobile, turn grid into slider with 1.2 slides per view and no effect
  const swiper = new Swiper(container, {
    slidesPerView: 1.35,
    spaceBetween: 24,
    loop: false,
    freeMode: true,
    allowTouchMove: true,
    navigation: {
      nextEl: nextEl || undefined,
      prevEl: prevEl || undefined,
    },
    breakpoints: {
        1560: {
            slidesPerView: 4.2,
            spaceBetween: 24,
        },
        1280: {
            slidesPerView: 3.2,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2.45,
            spaceBetween: 24,
        },
        550: {
            slidesPerView: 1.35,
            spaceBetween: 24,
        },
    },
  });
});